import React, { Component } from 'react'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import cx from 'classnames'

export default class DesktopPreferencesForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      expanded: true
    }
    this.toggleExpand = this.toggleExpand.bind(this)
  }

  toggleExpand() {
    this.setState({ expanded: !this.state.expanded })
  }

  render() {
    const {
      fields: { servicingCompletions, issues, unsatisfactory, delayed },
      error,
      submitting,
      handleSubmit
    } = this.props
    const {
      expanded
    } = this.state

    return (
      <form onSubmit={handleSubmit}>
        <div className="expandable">
          <h1>Desktop Notifications</h1>
          <img onClick={this.toggleExpand} className={cx('toggle-button', { '_up': expanded })} src={require('../../images/arrow-down.svg')} />
          { expanded &&
            <ReactCSSTransitionGroup
              component='div'
              transitionName='workOrderGroup'
              transitionEnterTimeout={250}
              transitionLeaveTimeout={250}
            >
              <div className='checkbox-group'>
                <div className='checkboxes-container'>
                  <div>
                    <label>
                      <input
                        type='checkbox'
                        value={servicingCompletions.value}
                        {...servicingCompletions}
                        onChange={event => {
                          servicingCompletions.onChange(event)
                          setTimeout(handleSubmit)
                        }}/>
                      <span className='indicator'></span>
                      Servicing Completions
                    </label>
                  </div>
                  <div>
                    <label>
                      <input
                      type='checkbox'
                      value={issues.value}
                      {...issues}
                      onChange={event => {
                        issues.onChange(event)
                        setTimeout(handleSubmit)
                      }}/>
                      <span className='indicator'></span>
                      Issues
                    </label>
                  </div>
                  <div>
                    <label>
                      <input
                      type='checkbox'
                      value={unsatisfactory.value}
                      {...unsatisfactory}
                      onChange={event => {
                        unsatisfactory.onChange(event)
                        setTimeout(handleSubmit)
                      }}/>
                      <span className='indicator'></span>
                      Unsatisfactory
                    </label>
                  </div>
                  <div>
                    <label>
                      <input
                      type='checkbox'
                      value={delayed.value}
                      {...delayed}
                      onChange={event => {
                        delayed.onChange(event)
                        setTimeout(handleSubmit)
                      }}/>
                      <span className='indicator'></span>
                      Delayed
                    </label>
                  </div>
                </div>
              </div>
            </ReactCSSTransitionGroup>
          }
        </div>
      </form>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/settings/desktop-preferences-form.js